<form [formGroup]="negatievePremies">
  <div>

        <snelstart-ui-number-form-control formControlName="terugontvangenPremieLijfrente"
                                          id="terugontvangenPremieLijfrente"
                                          class="custom-input-250"
                                          [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          label="Ontvangen premies lijfrente"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
  </div>
  <div>
        <snelstart-ui-number-form-control formControlName="terugontvangenPremieAOV"
                                          id="terugontvangenPremieAOV"
                                          class="custom-input-250"
                                          [decimals]="0"
                                          align="right"
                                          prefix="€"
                                          label="Ontvangen premies arb.ong.verz."
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
  </div>
</form>


